import clsx from "clsx";
import { useRef } from "react";
import { Slide } from "react-slideshow-image";
import Image from "@Components/Image";
import { CMSImageType } from "../../types/Contentful";
import classes from "./RecipesDetail.module.scss";
import "react-slideshow-image/dist/styles.css";

interface Props {
  imageList: CMSImageType[];
}

export const Carousel = ({ imageList }: Props) => {
  const carouselRef = useRef<Slide>(null);

  if (!imageList?.length) return null;

  const indicators = (index: number) => {
    const activeIndex = carouselRef.current?.state?.index || 0;

    return (
      <div
        className={clsx(
          classes["indicator"],
          "indicator",
          activeIndex === index && classes["active"]
        )}
      />
    );
  };

  return (
    <Slide
      autoplay={false}
      arrows={imageList.length > 1}
      indicators={imageList.length > 1 ? indicators : null}
      ref={carouselRef}
      transitionDuration={200}
    >
      {imageList.map((image, index) => (
        <div className="each-slide" key={index}>
          <div className={classes["image"]}>
            <Image
              width="100%"
              height="100%"
              layout="responsive"
              objectFit="cover"
              src={`${image?.url}?fm=webp&w=1680&h=1680`}
              alt="Recipe"
            />
          </div>
        </div>
      ))}
    </Slide>
  );
};
